import React, { ComponentType, FC, ReactNode } from "react";
import { Route, RouteComponentProps, Redirect } from "wouter";
import { useSelector } from "react-redux";
import { IState } from "store/store.interface";
import { isEmpty } from "utils/app.utils";
import { useApiInfo } from "hooks";
import {
  AUTH_GET_USER,
  CONFIG_GET,
  AUTH_SWITCH_STORE,
  AUTH_VERIFY_BOUND_STORE,
} from "store/store.types";
import Loader from "Loader/Main";
import useAuthenticate from '../../hooks/useAuthenticate'
interface IProps {
  children?: ReactNode;
  component?: ComponentType<RouteComponentProps>;
  path: string;
}
const ProtectedRoute: FC<IProps> = ({ component, ...rest }) => {
  const { storeId, storeIds = [], userPermissions, statusPermissions } =
    useSelector((state: IState) => ({ ...state.auth, ...state.config }));
  const { isLoading: isGetUserLoading, success: getUserSuccess } = useApiInfo(AUTH_GET_USER);
  const { isLoading: isGetConfigLoading } = useApiInfo(CONFIG_GET);
  const { isLoading: isSwitchStorePosting, done: switchStorePostDone, success: switchStorePostSuccess } = useApiInfo(AUTH_SWITCH_STORE);
  const { isLoading: isVerifyingBoundStore, done: verifyBoundStoreDone, success: switchStoreSuccess } = useApiInfo(AUTH_VERIFY_BOUND_STORE);
  const { isAuthenticated, inProgress } = useAuthenticate();
  const needsServerStoreBind = storeIds.length > 1;
  const isSwitchStoreLoading = isSwitchStorePosting || isVerifyingBoundStore;
  const switchStoreDone = !needsServerStoreBind
    || (switchStorePostDone && (!switchStorePostSuccess || verifyBoundStoreDone));

  if (
    inProgress
    || isGetConfigLoading
    || isGetUserLoading
    || (needsServerStoreBind && storeId && !switchStoreSuccess && (isSwitchStoreLoading || !switchStoreDone))
  ) {
    return <Loader />;
  }
  if (
    isAuthenticated &&
    getUserSuccess &&
    storeId &&
    needsServerStoreBind &&
    switchStoreDone &&
    !switchStoreSuccess
  ) {
    return <Redirect to="/login" />;
  }
  if (
    isAuthenticated &&
    storeId &&
    !isEmpty(userPermissions) &&
    !isEmpty(statusPermissions)
  ) {
    return <Route component={component} {...rest} />;
  }
  return <Redirect to="/logout" />;
};

export default ProtectedRoute;
